module.exports = __webpack_public_path__ + "static/media/bonus-circle.50db5a9f.png";